import { SVGProps } from "react";

export const SortingGradeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="75"
      height="75"
      viewBox="0 0 50 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.12501 23.875C3.12501 34.5676 11.3868 43.3305 21.875 44.1284V47.2613C9.65934 46.4573 0 36.2942 0 23.875C0 10.9308 10.4933 0.4375 23.4375 0.4375C35.8568 0.4375 46.0199 10.097 46.8238 22.3127C44.5319 22.3311 42.5338 23.5832 41.4611 25.4375H26.5625C23.9737 25.4375 21.875 23.3389 21.875 20.75V3.62171C11.3868 4.41956 3.12501 13.1825 3.12501 23.875ZM43.6909 22.3125C42.9322 12.34 34.9726 4.38033 25 3.62171V20.75C25 21.613 25.6996 22.3125 26.5625 22.3125H43.6909ZM43.75 28.5625C43.75 26.8367 45.1491 25.4375 46.875 25.4375C48.6009 25.4375 50 26.8367 50 28.5625V50.4376C50 52.1635 48.6009 53.5626 46.875 53.5626C45.1491 53.5626 43.75 52.1635 43.75 50.4376V28.5625ZM25 41.0626C25 39.3367 26.3992 37.9376 28.125 37.9376C29.8509 37.9376 31.2501 39.3367 31.2501 41.0626V50.4376C31.2501 52.1635 29.8509 53.5626 28.125 53.5626C26.3992 53.5626 25 52.1635 25 50.4376V41.0626ZM34.3751 34.8126C34.3751 33.0867 35.7742 31.6876 37.5001 31.6876C39.226 31.6876 40.6251 33.0867 40.6251 34.8126V50.4376C40.6251 52.1635 39.226 53.5626 37.5001 53.5626C35.7742 53.5626 34.3751 52.1635 34.3751 50.4376V34.8126Z"
        fill="white"
      />
    </svg>
  );
};
